var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.canEdit)?_c('div',[_c('plot-options-edit')],1):_c('div',[_c('plot-options-browse')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }